import { ButtonTypes } from "../../Button";
import { ConfirmTone } from "./types";

export const CONFIRM_BUTTON_TYPE: Record<ConfirmTone, ButtonTypes> = {
  danger: ButtonTypes.danger,
  warning: ButtonTypes.warning,
};
